import { createFileRoute } from "@tanstack/react-router";
import { PortalPage } from "@/components/portal/PortalPage";
import {
  buildSeo,
  hasFilterQuery,
  portalBreadcrumbJsonLd,
  portalDescriptionFor,
  portalTitleFor,
} from "@/lib/seo";

export const Route = createFileRoute("/portal/")({
  loaderDeps: ({ search }) => ({ filtered: hasFilterQuery(search as any) }),
  loader: ({ deps }) => ({ filtered: !!deps.filtered }),
  head: ({ loaderData }) => {
    const labels = {};
    const { title } = portalTitleFor(labels, 0);
    return buildSeo({
      title,
      description: portalDescriptionFor(labels, 0),
      path: "/portal",
      noindex: !!loaderData?.filtered,
      jsonLd: [portalBreadcrumbJsonLd(labels, "/portal")],
    });
  },
  component: () => <PortalPage segments={[]} />,
});

